import store from "/@/store";
import { getRoot } from "/@/root";
import { ELocalStorageKey } from "/@/types";
import { getDeviceBySn } from "/@/api/manage";
import { message } from "ant-design-vue";
import dockIcon from "/@/assets/icons/dock.png";
import rcIcon from "/@/assets/icons/rc.png";
import droneIcon from "/@/assets/icons/drone.png";
import { ref, onUnmounted } from "vue";
import pin2d8cf0 from "/@/assets/icons/pin-e23c39.svg";
import { judgeArrNaN, safeParseFloat } from '/@/utils/common'
import CreateFrustum from '/@/hooks/use-g-wayline-view'

export function deviceTsaUpdate() {
  const root = getRoot();
  const markers = store.state.markerInfo.coverMap;
  const paths = store.state.markerInfo.pathMap;
  // 工地标记
  const mapBillboard = ref<any>([])
  const icons = {
    0: droneIcon,
    2: rcIcon,
    3: dockIcon,
  };
  const markerFirstCenter = ref<boolean>(true);
  const markerNumSn = ref<string>("");
  const markerFlag = ref<boolean>(false);
  const dockSn = ref<any>([]);
  const dockCenter = ref<any>([]);
  let createFrustumData = null as any // 视锥体实例化
  const frustumOrigin = ref<any>([]) // 视锥体原点经纬度高度
  // 实体集合
  function initMarker(
    type: number,
    name: any,
    sn: string,
    pos?: any,
    checksn?: string,
    dockPosition?: any
  ) {
    dockSn.value.push(sn);
    if (!pos) {
      return;
    }
    if (pos.length < 2) {
      return;
    }
    if (checksn && markerNumSn.value && checksn != markerNumSn.value) {
      if (dockPosition?.length > 0 && pos[0] == dockPosition[0]) {
        markerFlag.value = true;
      }
    }
    if (sn == checksn) {
      if (dockPosition) {
        dockCenter.value = dockPosition;
      }
      // dockCenter.value = [lng,lat]
      markerNumSn.value = checksn;
    }
    const mapinstancegmap = root.$mapinstancegmap
    if (markers[sn]) {
      if (markerFirstCenter.value && checksn) {
        if (dockPosition?.length > 0) {
          // 设置中心
          mapinstancegmap.viewer.camera.flyTo({
            // fromDegrees()方法，将经纬度和高程转换为世界坐标
            destination: Cesium.Cartesian3.fromDegrees(
              dockPosition[0],
              dockPosition[1],
              5000.0
            ),
          });
          markerFirstCenter.value = false;
        }
      }
      if (checksn && markerFlag.value && dockPosition) {
        mapinstancegmap.viewer.camera.flyTo({
          // fromDegrees()方法，将经纬度和高程转换为世界坐标
          destination: Cesium.Cartesian3.fromDegrees(
            dockPosition[0],
            dockPosition[1],
            5000.0
          ),
          // orientation: {
          //   heading: Cesium.Math.toRadians(0), // 水平角度
          //   pitch: Cesium.Math.toRadians(-5), // 俯仰角度
          //   roll: 0 // 旋转角度
          // },
          // duration: 1 // 动画过渡时间，单位为秒
        });
        markerFlag.value = false;
        markerNumSn.value = checksn;
      }
      return;
    }
    if (mapinstancegmap === undefined) {
      return;
    }
    if (judgeArrNaN(pos) && safeParseFloat(pos[0]) && safeParseFloat(pos[1]) && safeParseFloat(pos[2])) {
      try {
        // 创建广告牌位置属性
        let positionProperty = new Cesium.CallbackProperty(function () {
          // 在这里计算广告牌的新位置
          let lon = safeParseFloat(pos[0]); // 广告牌的经度
          let lat = safeParseFloat(pos[1]); // 广告牌的纬度
          let height = safeParseFloat(pos[2]); // 广告牌的高度
          // 将经纬度和高度转换为Cartesian3坐标
          let cartesian = Cesium.Cartesian3.fromDegrees(lon, lat, height);
    
          // 返回新的位置值
          return cartesian;
        }, false);
        let imgs = dockIcon
        if (type == 0) {
          imgs = droneIcon
        }else if (type == 2) {
          imgs = rcIcon
        }else if (type == 3) {
          imgs = dockIcon
        }
        if(mapinstancegmap.viewer.entities.getById(`${sn}`)) {
          return
        }
        markers[sn] = mapinstancegmap.viewer.entities.add({
            id:sn,
            billboard: {
                image: imgs,
                width: 40,
                height: 40,
                // alignedAxis : new Cesium.VelocityVectorProperty(markers[sn].position, true)
            },
            position: positionProperty
        })
      } catch (error) {
        console.log('tsa-initMarker:',error);
      }
    }
  }

  function removeMarker(sn: string) {    
    const mapinstancegmap = root.$mapinstancegmap
    if (!markers[sn]) {
      return;
    }
    if(mapinstancegmap.viewer.entities.getById(`${sn}`)) {
      mapinstancegmap.viewer.entities.remove({id: `${sn}`})  
    }
    delete markers[sn];
    delete paths[sn];
  }

  function addMarker(sn: string, pos?: object) {
    getDeviceBySn(localStorage.getItem(ELocalStorageKey.WorkspaceId)!, sn).then(
      (data) => {
        if (data.code !== 0) {
          message.error(data.message);
          return;
        }
        // console.log(1455,data.data.domain);

        initMarker(data.data.domain, data.data.nickname, sn, pos);
      }
    );
  }
  const planeNum = ref<string>("");
  // 存飞机移动的经纬度，便于计算角度
  const planPos = ref();
  function moveTo(
    sn: string,
    lng: number,
    lat: number,
    height?: any,
    gimbals?: any
  ) {
    if (safeParseFloat(lng) && safeParseFloat(lat)) {
      let marker = markers[sn];
      planeNum.value = sn;
      let beforePos = [];
      if (planPos.value && planPos.value.length > 0) {
        const psi = JSON.parse(JSON.stringify(planPos.value));
        beforePos = psi;
      }
      planPos.value = [safeParseFloat(lng), safeParseFloat(lat)];
      // 当飞机图标不存在时绘制飞机图标
      if (!marker) {
        if (!height) {
          height = 600;
        }
        addMarker(sn, [safeParseFloat(lng), safeParseFloat(lat), safeParseFloat(height)]);
        marker = markers[sn];
        return;
      }
      // 飞机图标存在时，动态改变位置
      const poss = [safeParseFloat(lng), safeParseFloat(lat), safeParseFloat(height)]
      if (judgeArrNaN(poss) && safeParseFloat(lng) && safeParseFloat(lat) && safeParseFloat(height)) {
        try {
          let positionProperty = new Cesium.CallbackProperty(function (time, result) {
            // 在这里计算广告牌的新位置
            // 将经纬度和高度转换为Cartesian3坐标
            let cartesian = Cesium.Cartesian3.fromDegrees(safeParseFloat(lng), safeParseFloat(lat), safeParseFloat(height));        
            // 返回新的位置值
            return cartesian;
          }, false);
          marker.position = positionProperty;
          try {
            marker.billboard.alignedAxis = new Cesium.VelocityVectorProperty(marker.position, true)
          } catch (error) {
            console.log(21111,error);
          }
          if (beforePos.length > 0) {
            // 设置角度
            if (!gimbals) {
              return;
            }
            const newAng = parseFloat(gimbals);
            marker.billboard.rotation = Cesium.Math.toRadians(-newAng); // 更新旋转角度
          }
          
        } catch (error) {
          console.log('tsa-moveTo:',error);
        }
      }
    }
  }

  // 绘制菱形
function drawMarker(pos:any,name:string){ 
  if (!pos) {
      return
  }
  const mapinstancegmap = root.$mapinstancegmap
  if (judgeArrNaN(pos) && safeParseFloat(pos[0]), safeParseFloat(pos[1]), safeParseFloat(pos[2])) {
    try {
      const position = Cesium.Cartesian3.fromDegrees(safeParseFloat(pos[0]), safeParseFloat(pos[1]), safeParseFloat(pos[2] || 0));
        let billboard = mapinstancegmap.viewer.entities.add({
          position: position,
          billboard: {
            color: Cesium.Color.fromCssColorString('#fff').withAlpha(0.8),
            // color: new Cesium.Color(1.0,1.0,1.0,0.8),
            image: pin2d8cf0,
            scale: 2,
            // pixelOffset: this.style.pixelOffset,
            heightReference: 1,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            // 按距离缩放
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
            eyeOffset: new Cesium.Cartesian3(0, 0, -90),//Label 被建筑物遮挡问题
    
          },
          label:{
            // text: '测试',
            text: name,
            // pixelOffset: this.style.pixelOffset, //偏移量
            pixelOffset: new Cesium.Cartesian2(25, -50), //偏移量
            font: '600 16px',
            // horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            heightReference: 1,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            fillColor: Cesium.Color.fromCssColorString('#fff'), //字体颜色
            showBackground: true,
            backgroundColor: new Cesium.Color(0.5, 0.6, 1, 1.0),//背景色
            // disableDepthTestDistance: Number.POSITIVE_INFINITY,
            eyeOffset: new Cesium.Cartesian3(0, 0, -100),//Label 被建筑物遮挡问题
    
            // 按距离缩放
            scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2, 20000, 0.0),
          }
        })
        mapBillboard.value.push(billboard)
      
    } catch (error) {
      console.log('tsa-drawMarker:',error);
    }
  }
}
// 销毁菱形
function destoryMarker(){
  const mapinstancegmap = root.$mapinstancegmap
  if (mapBillboard.value && mapBillboard.value.length > 0) {
    mapBillboard.value.map((item:any)=>{
      mapinstancegmap.viewer.entities.remove(item)
    })
    mapBillboard.value = []
  }
  
}
  onUnmounted(() => {
    markerNumSn.value = "";
    markerFlag.value = false;
    markerFirstCenter.value = true;
    const datas = [...new Set(dockSn.value)];
    if (datas && datas.length > 0) {
      datas.map((item:any) => {
        markers[item] = null;
      });
    }
    destoryMarker()
  });

// flyto 移动
function flytoPoint(lng:number,lat: number,height: number){
  const mapinstancegmap = root.$mapinstancegmap
  if (mapinstancegmap) {
    let lngs = safeParseFloat(lng)
    let lats = safeParseFloat(lat)
    let heights = safeParseFloat(height)
    if (lngs && lats && heights) {
      mapinstancegmap.viewer.camera.flyTo({
        // fromDegrees()方法，将经纬度和高程转换为世界坐标
        destination: Cesium.Cartesian3.fromDegrees(lngs,lats,heights),
      });
    }
  }
}
// 判断两个数组是否相等
function arraysAreEqual(arr1:any, arr2:any) {
  // 首先检查数组的长度是否相等
  if (arr1.length!== arr2.length) {
      return false;
  }
  // 遍历数组的每个元素
  for (let i = 0; i < arr1.length; i++) {
      // 如果对应位置的元素不相等，则返回 false
      if (arr1[i]!= arr2[i]) {
          return false;
      }
  }
  // 如果所有元素都相等，则返回 true
  return true;
}
// 计算相机的四元数方向
const calculateCameraOrientation = (camera:any) => {
  if (camera) {
    let viewMatrix = camera.viewMatrix;
    // 提取旋转部分并转置
    let rotationMatrix3 = new Cesium.Matrix3();
    Cesium.Matrix4.getRotation(viewMatrix, rotationMatrix3);
    Cesium.Matrix3.transpose(rotationMatrix3, rotationMatrix3);
    // // 转换为四元数
    let quaternion = Cesium.Quaternion.fromRotationMatrix(rotationMatrix3);
    return quaternion
  }else{
    return null
  }
}
// 初始化视锥体
function initFrustum(params:any){
  const { lng, lat, height, mapviewer, viewer } = params
  if (viewer && mapviewer) {
    const camera = mapviewer.camera
    let origin = Cesium.Cartesian3.fromDegrees(lng, lat,height);
    let orientation = calculateCameraOrientation(camera)
    const flag = arraysAreEqual(frustumOrigin.value,[lng, lat,height])
    // flag为true 两个数组相等
    // if (flag) {
    //   return
    // }
    frustumOrigin.value = [lng,lat,height]
    if (createFrustumData) {
      createFrustumData.updatePosition(origin, orientation);
      return
    }
    let fov = 0.5
    // 创建视锥体
    createFrustumData = new CreateFrustum({
        position: origin,
        orientation: orientation,
        fov: fov,
        near: 0.1,
        far: 200,
        aspectRatio: 600 / 600,
        viewer: viewer,
    });
  }
}
// 清除视锥体
function clearFrustum(){
  if (createFrustumData) {
    createFrustumData.clear()
    createFrustumData = null
  }
}
  return {
    marker: markers,
    initMarker,
    removeMarker,
    moveTo,
    // createMaker,
    // startAnimation,
    drawMarker,
    destoryMarker,
    flytoPoint,
    initFrustum, // 创建视锥体
    clearFrustum, // 清除视锥体
  };
}
